module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/reason_04_sp-d23f97a2820985c29c7beb2229d54846.png";